<template>
  <b-row class="progress-box" align-v="center" align-h="between">
    <b-col cols="" class="progress-box__progressbar">
      <span
        :class="`progress-box__progress background-${variant} width-percent-${width} ${direction}-0`"
      >
      </span>
    </b-col>
    <b-col v-if="isWidthText" cols="auto" class="progress-box__percent">
      <slot name="text-area"> {{ width }}% </slot>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "success",
    },
    width: {
      type: [Number, String],
      default: 0,
    },
    direction: {
      type: String,
      default: "left",
    },
    isWidthText: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
